module.exports = __webpack_public_path__ + "static/media/header.904da558.png";